module.exports = __webpack_public_path__ + "static/media/strategy-pt.625a0c5b.png";